<div class="gt-routes-list-containerss">
  <div class="col-container">
    <div class="col">
      <h2 i18n="@@contractTypes">Contract Types</h2>
      <dx-data-grid
        #contractTypesGrid
        [dataSource]="contractTypes"
        (onSaving)="saveContractType($event)"
      >
        <dxo-selection mode="single"></dxo-selection>
        <dxo-search-panel
          [visible]="true"
          [highlightCaseSensitive]="false"
          class="gt-search-panel"
          width="17vw"
          i18n-placeholder="@@search..."
          placeholder="Search..."
        ></dxo-search-panel>
        <dxo-toolbar>
          <dxi-item width="50%" name="searchPanel" location="before"></dxi-item>
          <dxi-item width="50%">
            <div class="gt-flex-dir-row">
              <app-gpd-button
                icon="add"
                i18n-text="@@add"
                text="Add"
                (onClick)="addNewContractType()"
              ></app-gpd-button>
            </div>
          </dxi-item>
        </dxo-toolbar>
        <dxo-editing mode="form" [texts]="editText"></dxo-editing>
        <dxi-column
          dataField="name"
          i18n-caption="@@contractType"
          caption="Contract Type"
          sortOrder="asc"
        >
          <dxi-validation-rule
            type="required"
            i18n-message="@@contractTypeIsRequired"
            message="Contract Type is required"
          ></dxi-validation-rule>
          <dxi-validation-rule
            type="custom"
            i18n-message="@@contractTypeExists"
            [validationCallback]="validateContractTypeDuplicateName"
            message="Contract Type already exists"
          ></dxi-validation-rule>
        </dxi-column>
        <dxi-column
          dataField=""
          allowEditing="false"
          cellTemplate="buttonCellTemplate"
          [width]="68"
          [visible]="true"
          [formItem]="{ visible: false }"
        >
          <div *dxTemplate="let item of 'buttonCellTemplate'">
            <!-- Standard types (e.g. Gesellschaftsvertrag) are used by the app itself: no rename, no delete. -->
            <div class="gpd-table-actions" *ngIf="item.data.systemKey; else editableType">
                <app-svg-icon icon="lock" color="var(--color-grey-500)" [size]="20" [strokeWidth]="1.5" i18n-title="@@standardContractTypeHint" title="Standard contract type: it cannot be renamed or deleted"></app-svg-icon>
            </div>
            <ng-template #editableType>
            <div class="gpd-table-actions">
                <app-svg-icon icon="edit" color="var(--color-primary)" [size]="20" [strokeWidth]="1.5" i18n-title="@@edit" title="Edit" [class.disabled]="userPermissions.isAdministrator == false || userPermissions.canEdit == false" (click)="!(userPermissions.isAdministrator == false || userPermissions.canEdit == false) && editContractType(item.data.id)"></app-svg-icon>
                <app-svg-icon icon="delete" color="var(--color-red-500)" [size]="20" [strokeWidth]="1.5" i18n-title="@@delete" title="Delete" [class.disabled]="userPermissions.isAdministrator == false || userPermissions.canDelete == false" (click)="!(userPermissions.isAdministrator == false || userPermissions.canDelete == false) && deleteContractType(item.data)"></app-svg-icon>
              </div>
            </ng-template>
          </div>
        </dxi-column>
      </dx-data-grid>
    </div>
    <div class="col">
      <h2 i18n="@@deadlineTypes">Deadline Types</h2>
      <dx-data-grid
        #deadlineTypesGrid
        [dataSource]="deadlineTypes"
        (onSaving)="saveDeadlineType($event)"
        keyExpr="id"
      >
        <dxo-selection mode="single"></dxo-selection>
        <dxo-search-panel
          [visible]="true"
          [highlightCaseSensitive]="false"
          class="gt-search-panel"
          width="17vw"
          i18n-placeholder="@@search..."
          placeholder="Search..."
        ></dxo-search-panel>
        <dxo-toolbar>
          <dxi-item width="50%" name="searchPanel" location="before"></dxi-item>
          <dxi-item width="50%">
            <div class="gt-flex-dir-row">
              <app-gpd-button
                icon="add"
                i18n-text="@@add"
                text="Add"
                (onClick)="addNewDeadlineType()"
              ></app-gpd-button>
            </div>
          </dxi-item>
        </dxo-toolbar>
        <dxo-editing mode="form" [texts]="editText"></dxo-editing>
        <dxi-column
          dataField="name"
          i18n-caption="@@deadlineType"
          caption="Deadline Type"
          sortOrder="asc"
        >
          <dxi-validation-rule
            type="required"
            i18n-message="@@deadlineTypeIsRequired"
            message="Deadline Type is required"
          ></dxi-validation-rule>
          <dxi-validation-rule
            type="custom"
            i18n-message="@@deadlineTypeExists"
            [validationCallback]="validateDeadlineTypeDuplicateName"
            message="Deadline Type already exists"
          ></dxi-validation-rule>
        </dxi-column>
        <dxi-column
          dataField=""
          allowEditing="false"
          cellTemplate="buttonCellTemplate"
          [width]="68"
          [visible]="true"
          [formItem]="{ visible: false }"
        >
          <div *dxTemplate="let item of 'buttonCellTemplate'">
            <div class="gpd-table-actions">
                <app-svg-icon icon="edit" color="var(--color-primary)" [size]="20" [strokeWidth]="1.5" i18n-title="@@edit" title="Edit" [class.disabled]="userPermissions.isAdministrator == false || userPermissions.canEdit == false" (click)="!(userPermissions.isAdministrator == false || userPermissions.canEdit == false) && editDeadlineType(item.data.id)"></app-svg-icon>
                <app-svg-icon icon="delete" color="var(--color-red-500)" [size]="20" [strokeWidth]="1.5" i18n-title="@@delete" title="Delete" [class.disabled]="userPermissions.isAdministrator == false || userPermissions.canDelete == false" (click)="!(userPermissions.isAdministrator == false || userPermissions.canDelete == false) && deleteDeadlineType(item.data)"></app-svg-icon>
              </div>
          </div>
        </dxi-column>
      </dx-data-grid>
    </div>
  </div>
</div>
